import React from 'react';
import PropTypes from 'prop-types';
import { Switch } from 'react-router-dom';
import { BundleRoute } from '@saucelabs/sl-component-router';

const importJobDetails = () => import(/* webpackChunkName: "job-details" */ './containers/JobContainer');
const importRawJob = () => import(/* webpackChunkName: "job-raw" */ './containers/JobRawContainer');


const JobRoutes = ({ match }) => (
  <Switch>
    <BundleRoute
      exact
      load={importRawJob}
      path={`${match.url}/:jobId/raw`}
    />
    <BundleRoute
      load={importJobDetails}
      path={`${match.url}/:jobId`}
    />
  </Switch>
);

JobRoutes.propTypes = {
  match: PropTypes.object.isRequired,
};

export default JobRoutes;
export { JobRoutes };
